const pushNotificationReceived = (notification) => {
  console.log('services.firebase.callbacks.pushNotificationReceived called.', notification)
}

export default pushNotificationReceived
